const { ENTITY_TYPES } = require('../constants');

const extractCountryFromCityFilter = ({ entityType, entity, country, parents }) => {
  if (country) {
    return country;
  }

  if (entityType !== ENTITY_TYPES.CITY) {
    return null;
  }

  if (entity?.country) {
    return entity?.country;
  }

  return parents?.find(parent => parent.entityType === ENTITY_TYPES.COUNTRY)?.entity || null;
};

module.exports = extractCountryFromCityFilter;
